import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Score, SCORE_SIZE } from 'src/components/Score';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  score: PropTypes.number,
};

const defaultProps = {
  className: '',
  score: null,
};

export const ImageOverlayChip = forwardRef(({ className, text, score, ...restProps }, ref) => {
  const styles = useStyles();

  return (
    <div
      className={cx(styles.root, className)}
      ref={ref}
      {...restProps}
    >
      <TruncatedTypography
        className={styles.text}
        variant={TYPOGRAPHY_VARIANT.regular14}
      >
        {text}
      </TruncatedTypography>

      {score != null && (
        <Score
          className={styles.score}
          score={score}
          size={SCORE_SIZE.imageOverlayChip}
        />
      )}
    </div>
  );
});

ImageOverlayChip.displayName = 'ImageOverlayChip';
ImageOverlayChip.propTypes = propTypes;
ImageOverlayChip.defaultProps = defaultProps;
